module.exports = __webpack_public_path__ + "static/media/BW.3b70ec96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/BW.jpg
// module id = 1480
// module chunks = 0